<template>
  <!-- 行业地位 -->

  <el-form class="position" style="width:50%" :model="formData" label-width="4rem">
    <el-form-item label="图片">
      <el-upload class="avatar-uploader"  :http-request="uploadfile" action="" :show-file-list="false" >
        <img v-if="formData.describeUrl" :src="formData.describeUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </el-form-item>
    <!-- <el-form-item label="标题">
      <el-input v-model="formData.title"></el-input>
    </el-form-item> -->

    <el-form-item label="描述">
      <el-input type="textarea" :rows="6" v-model="formData.content"></el-input>
    </el-form-item>
    <div style="text-align: right;">
      <el-button @click="save" type="primary">保存</el-button>
    </div>
  </el-form>

</template>

<script>
import api from '@/apis/recommend/position'
import upapi from '@/apis/upload'
export default {
  data() {
    return {
      formData: {
        describeUrl:'https://dycn-v2.oss-cn-chengdu.aliyuncs.com/dycn-v2/20210615/5aa6e6044f5a46708dce1dd33aee8e8b.png',
        // title: '创研实力 自主创新 同步全球联塑',
        content: '',
      },
    }
  },
  mounted() {
    api.mine().then((res) => {
      if (res.code === 10000) {
        if (res.data) {
          this.formData = res.data
        }
      } else {
        this.$message.error(res.message)
      }
    })
  },
  methods: {
    save() {
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //上传图片
    uploadfile(val) {
      // console.log(val);
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.formData.describeUrl = res.data
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
</style>